import { render, staticRenderFns } from "./client-news.pug?vue&type=template&id=9e0aec1e&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./client-news.scss?vue&type=style&index=0&id=9e0aec1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0aec1e",
  null
  
)

export default component.exports